import { CheckCircle } from 'phosphor-react';

import OpencompIntroductionImage from 'assets/images/opencomp-introduction.svg';

function IntroduceOpencompCard(): JSX.Element {
  return (
    <div className="bg-blue-100 rounded px-8 py-10 flex justify-center">
      <img src={OpencompIntroductionImage} />
      <div className="pl-8 2xl:pl-24">
        <div className="heading-6 text-xl text-gray-900 font-bold">
          OpenComp gives you clarity at the point of every compensation decision
        </div>
        <div className="text-base text-gray-700 mt-2">
          Modernize your compensation program in hours. Answer the toughest pay questions in
          seconds.
        </div>
        <div className="bg-blue-200 rounded p-4 flex mt-4 text-sm font-semibold text-black">
          <div className="flex-1 flex items-center">
            <CheckCircle className="text-blue-500 inline mr-2" size={20} weight="bold" />
            Benchmark
          </div>
          <div className="flex-1 flex items-center">
            <CheckCircle className="text-blue-500 inline mr-2" size={20} weight="bold" />
            Plan
          </div>
          <div className="flex-1 flex items-center">
            <CheckCircle className="text-blue-500 inline mr-2" size={20} weight="bold" />
            Empower
          </div>
        </div>
        <a
          href="https://www.opencomp.com"
          target="_blank"
          className="btn-primary mt-6"
          rel="noreferrer">
          Try it for free
        </a>
      </div>
    </div>
  );
}

export default IntroduceOpencompCard;
